import './App.css';
import { AnimatePresence, motion } from "framer-motion";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Welcome from "./pages/welcome/Welcome";
import Exhibition from "./pages/exhibition/Exhibition";
import Languages from "./pages/languages/Languages";
import Player from "./pages/player/Player";
import Login from "./pages/login/Login";
import Exhibitions from "./pages/exhibitions/Exhibitions";
import CreateExhibition from "./pages/createExhibition/CreateExhibition";
import EditExhibition from "./pages/editExhibition/EditExhibition";
import Settings from "./pages/settings/Settings";

const animatedRoutePaths = ["/", "/languages", "/welcome", "/play"];

const routeTransition = {
    duration: 0.8,
    ease: "easeInOut",
};

const appRoutes = (
    <>
        <Route path="/" element={<Exhibition />} />
        <Route path="languages" element={<Languages />} />
        <Route path="welcome" element={<Welcome />} />
        <Route path="play" element={<Player />} />
        <Route path="dashboard">
            <Route path="create" element={<CreateExhibition/>} />
            <Route path="edit" element={<EditExhibition />} />
            <Route path="login" element={<Login />} />
            <Route path="exhibitions" element={<Exhibitions />} />
            <Route path="settings" element={<Settings />} />
        </Route>
    </>
);

function AppRoutes() {
    const location = useLocation();

    if (!animatedRoutePaths.includes(location.pathname)) {
        return (
            <Routes>
                {appRoutes}
            </Routes>
        );
    }

    return (
        <div className="route-transition-shell">
            <AnimatePresence>
                <motion.div
                    className="route-transition-page"
                    key={`${location.pathname}${location.search}`}
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={routeTransition}
                >
                    <Routes location={location}>
                        {appRoutes}
                    </Routes>
                </motion.div>
            </AnimatePresence>
        </div>
    );
}

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    </div>
  );
}

export default App;
